import React from "react";
import { Loader2, AlertCircle } from "lucide-react";
import { Card, CardContent } from "../../../components/ui/card";

// EMAILS-IMPL-007: shared loading/request-error presentation for every
// operational catalog section (Programs/Campaigns/Angles/Audiences), so
// all four read identically rather than four bespoke implementations.
export function CatalogLoadingCard({ testId }) {
  return (
    <Card className="glass border-white/10" data-testid={testId}>
      <CardContent className="flex items-center justify-center gap-2 p-12 text-slate-400">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Loading…</span>
      </CardContent>
    </Card>
  );
}

export function CatalogErrorCard({ message, testId }) {
  return (
    <Card className="border-rose-500/30 bg-rose-500/5" data-testid={testId}>
      <CardContent className="flex items-center gap-2 p-8 text-rose-200">
        <AlertCircle className="h-5 w-5 shrink-0" />
        <span>{message}</span>
      </CardContent>
    </Card>
  );
}
